module.exports = __webpack_public_path__ + "img/cabin-front.f41fc511.jpg";